// POST /assignments body for the My Drafts bulk flow.
//
// Built once, at the Question step, which is where a draft becomes a real row in
// My Drafts. That is well before the teacher picks marking tools or routes any
// page to a student, so the marking selection and classIds are both empty here
// and filled in later by the ordinary assignment update path.
const classIdsForStudents = (students, studentAssignments) => {
  const assignedIds = Object.keys(studentAssignments || {});
  const fromAssigned = assignedIds
    .map(
      (studentId) =>
        students.find((s) => String(s.id) === String(studentId))?.classId,
    )
    .filter(Boolean);
  const ids = fromAssigned.length
    ? fromAssigned
    : students.map((s) => s.classId).filter(Boolean);
  return [...new Set(ids)];
};

const subjectsFor = (subject) =>
  subject?.code ? [{ subjectCode: subject.code, subjectName: subject.title }] : [];

const yearsFor = (year) => (year != null && year !== '' ? [String(year)] : []);

const buildQuestion = (questionForm, markingSelection, taskType, settings = {}) => ({
  serialNumber: '1',
  question: questionForm.question,
  type: 'TEXT',
  options: [],
  focusAreaIds: [],
  focusAreas: [],
  markingCriteria: markingSelection?.markingCriteria || null,
  successCriterias: [],
  shortAnswers: [],
  // null, not '': the backend reads a blank id as a bank that has gone inactive and skips
  // the metadata lookup that gives a draft its specific comments (JED-1388).
  commentBankId: markingSelection?.commentBankId || null,
  stimulusText: questionForm.stimulusText || '',
  stimulusFiles: questionForm.stimulusFiles || [],
  introParagraphs: settings.introParagraphs ?? 0,
  bodyParagraphs: settings.bodyParagraphs ?? 1,
  conclusionParagraphs: settings.conclusionParagraphs ?? 0,
  responseType: settings.responseType ?? 'Full Response',
  taskType,
  showMarks: false,
  marksOutOf: settings.totalMarks ?? settings.marksOutOf ?? null,
  enabledFeedbackTypes: [],
});

export const buildDraftAssignmentPayload = (submissionData) => {
  const classIds = classIdsForStudents(
    submissionData.students || [],
    submissionData.studentAssignments,
  );

  const taskType = submissionData.selectedTaskType?.title || null;

  return {
    title: submissionData.questionForm.title,
    instructions: null,
    questions: [
      buildQuestion(
        submissionData.questionForm,
        submissionData.markingSelection,
        taskType,
        submissionData.draftSettings,
      ),
    ],
    classIds,
    subjects: subjectsFor(submissionData.selectedSubject),
    years: yearsFor(submissionData.selectedYear?.title),
    states: submissionData.draftSettings?.state ? [submissionData.draftSettings.state] : [],
    taskType,
    reviewedBy: 'JEDDAI_ASSISTED',
    reviewers: {},
    advancedMarkingSettingsByClassId: submissionData.advancedControls || {},
  };
};
